import { render, staticRenderFns } from "./PointDetailModal.vue?vue&type=template&id=6a31a66e&scoped=true"
import script from "./PointDetailModal.vue?vue&type=script&lang=js"
export * from "./PointDetailModal.vue?vue&type=script&lang=js"
import style0 from "./PointDetailModal.vue?vue&type=style&index=0&id=6a31a66e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a31a66e",
  null
  
)

export default component.exports